export const FETCH_SITE_EVENT_COUNTS_REQUEST = 'FETCH_SITE_EVENT_COUNTS_REQUEST';
export const FETCH_SITE_EVENT_COUNTS_SUCCESS = 'FETCH_SITE_EVENT_COUNTS_SUCCESS';
export const FETCH_SITE_EVENT_COUNTS_FAILURE = 'FETCH_SITE_EVENT_COUNTS_FAILURE';

export const FETCH_SITE_EVENT_DRILLABLE_COUNTS_REQUEST =
  'FETCH_SITE_EVENT_DRILLABLE_COUNTS_REQUEST';
export const FETCH_SITE_EVENT_DRILLABLE_COUNTS_SUCCESS =
  'FETCH_SITE_EVENT_DRILLABLE_COUNTS_SUCCESS';
export const FETCH_SITE_EVENT_DRILLABLE_COUNTS_FAILURE =
  'FETCH_SITE_EVENT_DRILLABLE_COUNTS_FAILURE';
